export const usePlaceholderImage = (props) => {
  const {
    displayPlaceholder, imageHasError, imageIsLoaded 
  } = props

  const hidePlaceholder =
        !displayPlaceholder || (imageIsLoaded && !imageHasError)
  const shouldRenderPlaceholder = !hidePlaceholder

  return {
    shouldRenderPlaceholder,
  }
}
